module.exports = __webpack_public_path__ + "img/human_male_20180517.5f72253b.png";